import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiCreditPack } from './types/OrgDashboardApiCreditPack';
import type { OrgDashboardApiPromoCredit } from './types/OrgDashboardApiPromoCredit';

type ApiResponse = {
  packs: OrgDashboardApiCreditPack[];
  promoCredits: OrgDashboardApiPromoCredit[];
  membershipPromoCredits: OrgDashboardApiPromoCredit[];
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) => `/data/orgdashboard/${orgId}/credits`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchCredits =
  endpoint.createIsomorphicFetchFn();
